import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { integrationSchemaRegistry } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { CloudwatchService } from '../../service';

export enum LogMetricFilterCheckType {
  RootUserUsage = 'root-user-usage',
  UnauthorizedApiCalls = 'unauthorized-api-calls',
  ManagementConsoleSignIn = 'management-console-sign-in',
  IamPolicyChanges = 'iam-policy-changes',
  CloudtrailConfigurationChanges = 'cloudtrail-configuration-changes',
  ConsoleAuthenticationFailures = 'console-authentication-failures',
  CustomerKeysDeletion = 'customer-keys-deletion',
  S3PolicyChanges = 's3-policy-changes',
  AwsConfigChanges = 'aws-config-changes',
  SecurityGroupChanges = 'security-group-changes',
  NetworkAclChanges = 'network-acl-changes',
  NetworkGatewayChanges = 'network-gateway-changes',
  RouteTableChanges = 'route-table-changes',
  VpcChanges = 'vpc-changes',
}

export type LogMetricFilterConfig = typeof LogMetricFilterConfig._.Config;

export const LogMetricFilterConfig = IntegrationConfig.make({
  service: CloudwatchService,
  name: Integration_Handler_Names_Enum.LogMetricFilter,
  configSchema: z.object({
    checks: z
      .array(
        z.enum(LogMetricFilterCheckType).register(integrationSchemaRegistry, {
          i18n: 'integrations.aws.services.cloudwatch.shared.log_metric_filter_check',
        }),
      )
      .min(1),
  }),
});
